import { render, staticRenderFns } from "./tabelaListagemCNPJFooter.vue?vue&type=template&id=51c16929"
import script from "./tabelaListagemCNPJFooter.vue?vue&type=script&lang=js"
export * from "./tabelaListagemCNPJFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports